export interface PerimeterGlintProps {
  /** Must match the host element's border-radius, in px. */
  radius?: number;
}

/**
 * A small polished highlight that travels the FULL rounded perimeter of its
 * host — top → corner → side → bottom → corner → side → back to top — instead
 * of sweeping one straight edge.
 *
 * Implemented as an SVG `<rect>` stroked with a short dash. `pathLength="100"`
 * normalises the perimeter to 100 units whatever the card's real size, so a
 * single `stroke-dashoffset: 0 → -100` is exactly one seamless lap at any
 * width, with no JS measurement and no resize handling. `rx` follows the host's
 * corner radius, so the highlight tracks the real corners.
 *
 * The host must be `position: relative`; this fills it and never paints inside
 * the interior, only along the border path.
 */
export function PerimeterGlint({ radius = 24 }: PerimeterGlintProps): JSX.Element {
  return (
    <svg className="glint" aria-hidden="true" focusable="false">
      <rect
        className="glint__path"
        x="0"
        y="0"
        width="100%"
        height="100%"
        rx={radius}
        ry={radius}
        pathLength="100"
        fill="none"
      />
    </svg>
  );
}
